export { default } from './Tooltip';
import { TooltipPosition as _TooltipPosition } from './Tooltip';
export type TooltipPosition = _TooltipPosition;
